export const BASE_PROVIDER_ID = "js-match-insights-provider";
export const JOB_DETAILS_PROVIDER_ID = `${BASE_PROVIDER_ID}-job-details`;
export const SERVICE_ID = BASE_PROVIDER_ID;
export const DEFAULT_MOE = 0;
